import { componentStyles } from "./tag.scss";
import Colors from "/styles/colors";

function Tag({ text, invertColors, useCasesTagesTextColor, useCasesTagsBackgroundColor, cardMainColor }) {
  const tagStyles = invertColors
    ? {
        backgroundColor: Colors[useCasesTagsBackgroundColor],
        color: Colors[useCasesTagesTextColor],
        borderColor: "transparent"
      }
    : { borderColor: Colors[cardMainColor], color: Colors[cardMainColor] };

  return (
    <div className="tag" style={tagStyles}>
      {text}
      <style jsx>{componentStyles}</style>
    </div>
  );
}

export default Tag;
